<template>
  <div class="app-header">
    <!-- 顶部条 -->
    <div class="header-top">
      <div class="top-container">
        <div class="logo">国内领先的域名专业服务平台</div>
        <div class="user-info">
          <div v-if="!isLogin">
            <span @click="goToRegister">注册</span>
            <el-divider direction="vertical" />
            <span @click="goToLogin">登录</span>
          </div>
          <div v-if="isLogin">
            <span>{{ userInfo.nickName }}</span>
            <el-divider direction="vertical" />
            <span style="cursor: pointer" @click="handleLoginOut">
              退出登录
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 主导航 -->
    <div class="header-main">
      <div class="main-container">
        <!-- 左侧区域 - 完全保持原有样式 -->
        <div class="header-left">
          <div class="header-logo">
            <img class="logo-img" src="@/assets/logo.png" alt="logo" />
          </div>
          <nav class="main-nav">
            <ul class="nav-list">
              <li class="nav-item">
                <router-link to="/" :class="{ active: $route.path === '/' }">
                  首页
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/ymjj" :class="{ active: $route.path === '/ymjj' }">
                  域名竞价
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/contact" :class="{ active: $route.path === '/contact' }">
                  域名商城
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/escrow" :class="{ active: $route.path === '/escrow' }">
                  担保交易
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/news" :class="{ active: $route.path === '/news' }">
                  域名资讯
                </router-link>
              </li>
            </ul>
          </nav>
        </div>

        <!-- 右侧客服信息 - 保持原有样式 -->
        <div class="header-right">
          <div class="contact-info">
            <span>客服电话：4000580110</span>
            <span style="margin-left: 30px">客服QQ:1375211687</span>
          </div>
        </div>

        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <el-icon><Menu /></el-icon>
        </div>
      </div>
    </div>

    <!-- 移动端菜单抽屉 -->
    <el-drawer
      v-model="mobileMenuVisible"
      title="导航菜单"
      :size="300"
      direction="ltr"
    >
      <div class="mobile-menu">
        <div class="menu-user" v-if="isLogin">
          <div class="user-name">{{ userInfo.nickName }}</div>
          <div class="user-action" @click="handleLoginOut">退出登录</div>
        </div>
        <div class="menu-auth" v-else>
          <el-button type="primary" @click="goToLogin" class="login-btn">
            登录
          </el-button>
          <el-button @click="goToRegister" class="register-btn">
            注册
          </el-button>
        </div>
        
        <div class="menu-nav">
          <router-link 
            to="/" 
            class="menu-item" 
            :class="{ active: $route.path === '/' }"
            @click="mobileMenuVisible = false"
          >
            首页
          </router-link>
          <router-link 
            to="/ymjj" 
            class="menu-item" 
            :class="{ active: $route.path === '/ymjj' }"
            @click="mobileMenuVisible = false"
          >
            域名竞价
          </router-link>
          <router-link 
            to="/contact" 
            class="menu-item" 
            :class="{ active: $route.path === '/contact' }"
            @click="mobileMenuVisible = false"
          >
            域名商城
          </router-link>
          <router-link 
            to="/escrow" 
            class="menu-item" 
            :class="{ active: $route.path === '/escrow' }"
            @click="mobileMenuVisible = false"
          >
            担保交易
          </router-link>
          <router-link 
            to="/news" 
            class="menu-item" 
            :class="{ active: $route.path === '/news' }"
            @click="mobileMenuVisible = false"
          >
            域名资讯
          </router-link>
        </div>

        <div class="menu-contact">
          <div class="contact-item">
            <el-icon><Phone /></el-icon>
            客服电话：4000580110
          </div>
          <div class="contact-item">
            <el-icon><ChatDotRound /></el-icon>
            客服QQ: 1375211687
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { userApi } from "@/api/index";
import { Menu, Phone, ChatDotRound } from "@element-plus/icons-vue";

const router = useRouter();

// 响应式判断
// const isMobile = computed(() => window.innerWidth <= 992);

// 状态管理
const userInfo = ref(null);
const isLogin = ref(false);
const mobileMenuVisible = ref(false);

// 获取用户信息
const getUserInfo = () => {
  userApi.getUserInfo().then((res) => {
    if (res.code === 200) {
      userInfo.value = res.user;
      isLogin.value = true;
    }
  });
};

// 退出登录
const handleLoginOut = () => {
  localStorage.removeItem("token");
  isLogin.value = false;
  userInfo.value = null;
  mobileMenuVisible.value = false;
  window.location.reload();
};

// 跳转登录
const goToLogin = () => {
  router.push("/login");
  mobileMenuVisible.value = false;
};

// 跳转注册
const goToRegister = () => {
  router.push("/register");
  mobileMenuVisible.value = false;
};

// 切换移动端菜单
const toggleMobileMenu = () => {
  mobileMenuVisible.value = !mobileMenuVisible.value;
};

// 初始化
onMounted(() => {
  if (localStorage.getItem("token")) {
    getUserInfo();
  }
});
</script>

<style scoped>
.app-header {
  background-color: #2c3e50;
  color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 顶部条样式 - 完全保持原有 */
.header-top {
  background: #f3f3f3;
  color: black;
  padding: 5px 0;
}

.top-container {
  width: 80%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 12px;
  color: #666;
}

.user-info > div {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #666;
}

.user-info span {
  cursor: pointer;
  transition: color 0.3s;
}

.user-info span:hover {
  color: #f60;
}

/* 主导航样式 - 保持原有布局 */
.header-main {
  background-color: #f60;
  padding: 0;
}

.main-container {
  /* width: 80%; */
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  position: relative;
}

/* 左侧区域 - 完全保持原有样式 */
.header-left {
  display: flex;
  align-items: center;
}

.header-logo {
  width: 145px;
  height: 100px;
  position: absolute;
  left: 0px;
  top: 0px;
  background: white;
  display: flex;
}

.logo-img {
  width: 100px;
  height: 100%;
  margin-left: 15px;
}

.main-nav {
  margin-left: 200px;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.nav-item a {
  color: white;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.nav-item a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-item a.active {
  background-color: white;
  color: black;
}

.nav-item a.router-link-exact-active {
  background-color: white;
}

/* 右侧客服信息 - 完全保持原有样式 */
.header-right {
  font-size: 20px;
  position: absolute;
  right: 50px;
}

.contact-info {
  color: white;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  cursor: pointer;
  font-size: 24px;
  color: white;
}

/* 移动端菜单样式 */
.mobile-menu {
  padding: 20px;
}

.menu-user {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.user-action {
  color: #f60;
  cursor: pointer;
  font-size: 14px;
}

.menu-auth {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.login-btn, .register-btn {
  flex: 1;
  height: 40px;
}

.login-btn {
  background: #f60;
  border: none;
  color: white;
}

.menu-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
}

.menu-item {
  padding: 12px 16px;
  color: #333;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.3s;
}

.menu-item:hover {
  background-color: #f8f9fa;
}

.menu-item.active {
  background-color: #f60;
  color: white;
}

.menu-contact {
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  color: #666;
  font-size: 14px;
}

.contact-item .el-icon {
  color: #f60;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .top-container,
  .main-container {
    width: 90%;
  }
  
  .main-nav {
    margin-left: 160px;
  }
  
  .header-right {
    right: 20px;
    font-size: 18px;
  }
}

@media (max-width: 992px) {
  .top-container,
  .main-container {
    width: 95%;
  }
  
  /* 隐藏桌面导航，显示移动菜单按钮 */
  .main-nav,
  .header-right {
    display: none;
  }
  
  .mobile-menu-btn {
    display: block;
  }
  
  /* 保持logo原有样式 */
  .header-logo {
    width: 145px;
    height: 100px;
    position: relative;
    left: auto;
    top: auto;
  }
  
  .logo-img {
    width: 100px;
    height: 100%;
    margin-left: 15px;
  }
  
  .main-container {
    height: 100px;
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .top-container {
    width: 100%;
    padding: 0 15px;
  }
  
  .main-container {
    width: 100%;
    padding: 0 15px 0px 0px;
  }
  
  .logo {
    font-size: 10px;
  }
  
  .user-info > div {
    font-size: 10px;
  }
  
  /* 保持logo原有样式，适当缩小 */
  .header-logo {
    width: 120px;
    height: 80px;
  }
  
  .logo-img {
    width: 80px;
    margin-left: 10px;
  }
  
  .main-container {
    height: 80px;
  }
  
  .mobile-menu-btn {
    font-size: 22px;
    margin-left: auto;
  }
}

@media (max-width: 480px) {
  /* 保持logo原有样式，进一步缩小 */
  .header-logo {
    width: 100px;
    height: 70px;
  }
  
  .logo-img {
    width: 70px;
    margin-left: 8px;
  }
  
  .main-container {
    height: 70px;
  }
  
  .mobile-menu-btn {
    font-size: 20px;
  }
}
</style>